import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    const subdomain = window.location.hostname.split('.')[0]
    
    if (subdomain === 'playground') {
      this.element.style.display = "none"
    }
  }
}